import './index.css'
import cn from 'clsx'

import React, { Component } from 'react'
import FileSelect from 'components/common/file-select'
import FileDropWrapper from 'containers/FileDropWrapper'
/**
 * Editable image component with drag-and-drop functionality
 * Supports image upload, preview, and removal with optional editing disable
 */
export default class EditableImage extends Component<{
  image?: string | File
  onImageSet: (...args: Array<any>) => any
  blankStateMessage?: string
  helpText?: React.ReactNode
  disableEditing?: boolean
}> {
  _onFileDrop: (files: Array<File>) => void = (files: File[]) => {
    // handle images only
    if (files[0]!.type.indexOf('image/') !== 0) return

    this._processImageFiles(files)
  }
  _processImageFiles: (files: Array<File>, triggerUpdate?: boolean) => void = (
    files: File[],
    triggerUpdate: boolean = true,
  ) => {
    // show preview without triggering server upload
    const reader = new FileReader()

    reader.onload = e => {
      if (e.target?.result) {
        this.props.onImageSet(e.target.result, files[0]!, triggerUpdate)
      }
    }

    reader.readAsDataURL(files[0]!)
  }
  _onRemove: (e: React.SyntheticEvent<EventTarget>) => void = (
    e: React.SyntheticEvent<any>,
  ) => {
    e.stopPropagation()
    this.props.onImageSet(null, null)
  }

  _renderBackground(): React.ReactElement<'div'> | React.ReactElement<'span'> {
    if (!this.props.image) {
      const message = !this.props.disableEditing
        ? this.props.blankStateMessage
        : 'No image'
      return <span className="Form_Droparea_Square_BlankText">{message}</span>
    }

    const backgroundStyle = {
      backgroundImage:
        typeof this.props.image === 'string'
          ? `url(${this.props.image})`
          : undefined,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
    }
    const removeButton = this.props.disableEditing ? null : (
      <button className="Form_ImageRemove" onClick={this._onRemove}>
        <i className="RemoveIcon" />
      </button>
    )
    return (
      <div className="Form_Droparea_Background" style={backgroundStyle}>
        {removeButton}
      </div>
    )
  }

  render(): React.ReactElement<'div'> {
    const { disableEditing } = this.props
    const imageClass = cn('EditableImage', {
      'is-editing-disabled': disableEditing,
    })
    const image = disableEditing ? (
      <div className={imageClass}>
        <div className="Form_Droparea_Square">{this._renderBackground()}</div>
      </div>
    ) : (
      <div className="EditableImage">
        <FileDropWrapper onDrop={this._onFileDrop}>
          <FileSelect
            className="Form_Droparea_Square"
            onChange={this._onFileDrop}
          >
            {this._renderBackground()}
          </FileSelect>
        </FileDropWrapper>
        {this.props.helpText}
      </div>
    )
    return image
  }
}
